import * as React from 'react';

const UpgradeIcon = ({fillColor = '#fff'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={10} height={10}>
    <path
      fill={fillColor}
      d="M8.618 8.638A.537.537 0 0 0 8.08 8.1H1.92a.537.537 0 1 0 0 1.076h6.16a.538.538 0 0 0 .538-.538ZM.84 4.285h.025l.852 3.085h6.566l.852-3.086.026.001a.64.64 0 1 0-.609-.443l-1.541.902-1.658-2.748a.64.64 0 1 0-.705 0L2.99 4.744 1.45 3.842a.64.64 0 1 0-.61.443Z"
    />
  </svg>
);

export default UpgradeIcon;
